/* eslint-disable no-nested-ternary */
import { Grid, Paper } from '@material-ui/core';
import { PaginationNumbers } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import MediaInfos from './Components/MediaInfos';

const DisplayMedia = ({ medias, imageInfo, info, scrollMedias, setScrollMedias, size, page, setPage, totalElements}) => {

  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const handleScroll = (e) => {
    if (scrollMedias) return;
    const { scrollHeight, scrollTop, clientHeight } = e.target;
    const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
    if (scrollPercentage >= 80) {
      setScrollMedias(true);
    }
  };

  return (
    <div className={classes.mainContainer}>
      <div className={cx(global.title, classes.title)}> Nos contenus médias </div>
      {medias?.length > 0 ? (
        <Grid
          container
          direction="column"
          className={css({
            backgroundColor: '#F3F7FF',
            marginTop: spacing(2),
            padding: spacing(2),
            borderRadius: 10,
            maxHeight: '154px',
            '@media only screen and (max-width: 768px)': {
              height: 'auto',
              overflowX: 'hidden',
              maxHeight: 'none',
            },
          })}
        >
          <div className={css({
            flexDirection: 'row',
            display: 'flex',
            gap: 16,
            paddingRight: medias.length > 2 ? spacing(2) : 0,
            overflowY: 'auto',
            flexWrap: 'wrap',
            '&::-webkit-scrollbar': {
              backgroundColor: '#F3F7FF',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#0060F9',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: '#C0D9FF',
            },
            '@media only screen and (max-width: 768px)': { overflow: 'hidden', padding: 0 },
            })}
            onScroll={(e) => handleScroll(e)}
          >
          {medias.map((item, index) => (
              <MediaInfos
                item={item}
                data={medias}
                imageInfo={imageInfo}
                index={index}
                info={info}
                page={page}
                isFirst={index === 0}
                isLast={index === medias?.length - 1}
              />
            ))}
          </div>
        </Grid>
      ) : (
        <div
          className={css({
            textAlign: 'center',
            color: '#5D75A8',
            padding: '20px',
            backgroundColor: 'white',
          })}
        >
          <FormattedMessage id="noElements" />
        </div>
      )}
      <div className={classes.pagination}>
        <PaginationNumbers
          onChange={(newPage) => setPage(newPage)}
          page={page}
          pageCount={size}
          totalCount={totalElements}
        />
      </div>
    </div>
  );
};

DisplayMedia.propTypes = {
  info: PropTypes.array,
  medias: PropTypes.array,
  imageInfo: PropTypes.string,
};

const styles = ({ fontSizes, spacing }) => ({
  title: {
    borderLeft: '3px solid #0060F9',
    paddingLeft: 8,
  },
  mainContainer: {
    backgroundColor: 'white',
    borderRadius: 10,
    padding: '20px',
    marginBottom: '25px',
  },
  block: {
    minHeight: '22vh',
    borderRadius: 10,
    padding: spacing(2),
    backgroundSize: 'cover',
    backgroundPosition: 'center',

    '@media (max-width:768px)': { minHeight: '10vh' },
  },
});
export default DisplayMedia;
